import { DesignSystem } from "../design-system";
import { Popover } from "./popover";
import { styles } from "./popover.styles";
import { template } from "./popover.template";
export const definition = Popover.compose({
    name: `${DesignSystem.prefix}-popover`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=popover.definition.js.map